import { Buis } from "~/components/Buis";
import { Dialog, DialogContent } from "~/components/ui/dialog";
import { useWidgetApp } from "~/provider";
import { cn } from "~/util/utils";
import { useDocumentContext } from "../../../providers/context";
import { ContentFrame } from "../ContentFrame";

export function ArticleDialog() {
	const { screen } = useWidgetApp();
	const { clickedArticle, setClickedArticle } = useDocumentContext();

	return (
		<Dialog
			open={!!clickedArticle()}
			onOpenChange={() => setClickedArticle(undefined)}
		>
			<DialogContent class={cn("max-w-3xl overflow-x-auto", screen() === "desktop" && "max-h-[90vh]")}>
				<div>
					<Buis
						class="text-gray-600 block mb-1.5"
						value={clickedArticle()?.breadcrumb}
					/>
					<Buis
						class="text-2xl block font-medium"
						value={clickedArticle()?.title}
					/>
				</div>
				<ContentFrame article={clickedArticle} />
			</DialogContent>
		</Dialog>
	);
}
